@if (order$ | async; as order) {
  <div class="cx-order-items container">
    <h4 class="cx-order-items-header">
      {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}
    </h4>
    <cx-promotions [promotions]="order.appliedOrderPromotions"></cx-promotions>
    <cx-cart-item-list [items]="order.entries" [readonly]="true"
    [promotionLocation]="promotionLocation"></cx-cart-item-list>
  </div>
}